/** @jsx jsx */
// import { jsx, ThemeProvider } from "theme-ui";
import { jsx } from "theme-ui";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";
import { navigate } from "gatsby";
import { selectorSrcmProfile } from "../state/selectors";
import { Login as L } from "../components/Login";
import { Modal } from "../components/Modal";
import Button1 from "../components/Button";

const { logintype } = getMandatoryEnv(["logintype"]);

const SignInButton = ({ btn, btnText, btnStyle = {} }) => {
  const srcmProfile = useSelector(selectorSrcmProfile);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (srcmProfile && logintype !== "keycloak") {
      setShow(false);
    }
  }, [srcmProfile]);

  const keycloakLogin = () => {
    const path =
      typeof window !== "undefined"
        ? `${window.location.pathname}${
            window.location.search ? `?${window.location.search}` : ""
          }`
        : "";
    localStorage.setItem("LandingPage", path);
    const auth = localStorage.getItem("pstate")
      ? JSON.parse(localStorage.getItem("pstate") || "")
      : "";
    if (auth?.user?.id) {
      navigate("/oneauth/authorization");
      return false;
    }
    localStorage.clear();
    localStorage.setItem("LandingPage", path);
    return true;
  };

  const showIt = useCallback(() => setShow(true), []);
  const hideIt = useCallback(() => setShow(false), []);

  if (!srcmProfile) {
    return (
      <div>
        {show && (
          <Modal handleClose={hideIt} showCloseBtn={false}>
            <L />
          </Modal>
        )}
        {btn ? (
          <div
            onClick={async () => {
              if (logintype === "keycloak") {
                if (await keycloakLogin())
                  document.querySelector("hfn-oneauth")?.triggerAuth();
              } else showIt();
            }}
            role="button"
            onKeyDown={async () => {
              if (logintype === "keycloak") {
                if (await keycloakLogin())
                  document.querySelector("hfn-oneauth")?.triggerAuth();
              } else showIt();
            }}
            tabIndex={0}
          >
            {btn}
          </div>
        ) : (
          <Button1 sx={btnStyle} onClick={showIt}>
            {btnText}
          </Button1>
        )}
      </div>
    );
  }
  return null;
};

SignInButton.propTypes = {
  btn: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  btnText: PropTypes.string,
  btnStyle: PropTypes.shape({}),
};

SignInButton.defaultProps = {
  btn: null,
  btnText: "Sign In",
  btnStyle: {},
};

export default SignInButton;
